<template>
	<div class="success-code" v-if="loading">
		<span class="icon iconfont iconlujing2 close" :class="{'bsStyle': s === 'BS' }"  @click="goPath('/home')" v-if="isShow"></span>
		<div class="success-code-wrap">
			<div class="logo">
				<span class="icon iconfont iconxingzhuangjiehe4"></span>
			</div>
			<p class="success-text">VIP赠送成功</p>
			<p class="desc desc1">好友{{ phone }} 的会员权益已开通</p>
			<p class="desc">会员有效期至<span class="date">{{ date.substr(0,11) }}</span></p>
			<button class="btn btn-blue" @click="share">微信告诉对方</button>
			<p class="free-btn">
				<span @click="goPath('/vip/vipfree')" v-if="isShow">继续赠送</span>
        <span @click="goHome" v-else>返回首页</span>
			</p>
		</div>
		<ShareTips :share-tip-show.sync="shareTipShow" />
    <van-popup v-model="browserShareTipShow" :style="{ width: '70%' }">
      <div class="browsersharetip">
        <div>使用浏览器的分享功能，把这条政策分享出去</div>
        <p @click="browserShareTipShow = false">知道了</p>
      </div>
    </van-popup>
	</div>
</template>

<script>
	import { cardShareInfo, reqGetPayResult, reqPayResultConfirmByOrderId } from '../../../api';
	import ShareTips from '@/components/shareTips'
	import { bridge, isMini } from '@/utils/util';
	import { isEmptyObject } from '../../../utils';
	import { Toast } from 'vant';

	export default {
		name: 'successFreeVip',
		components: {
			ShareTips
		},
		data() {
			return {
				shareTipShow: false, // 分享提示
				phone: "",
				date: '',
				orderId: null, // 订单id
				requestOrderId: null, // 支付单id
				s: localStorage.getItem('s'),
				loading: false,
        browserShareTipShow: false
			}
		},
    computed: {
    isShow() {
      return isMini() ? false : true
      }
    },
		mounted() {
			// if(version().weixin){
			// 	this.defalutShare()
			// }
      this.WX.miniProgram.postMessage({ data: {name: '赠送成功页面', title:'赠送成功页面测试' } })
			this.orderId = this.$route.query.orderId || null
			this.requestOrderId = this.$route.query.requestOrderId || null
			Toast.loading({
				duration: 0,
				message: '订单查询中...',
				forbidClick: true
			})
			// 获取支付订单信息
			if (this.orderId || this.requestOrderId) {
				this.timer = setInterval(() => this.getPayResult(), 1000);
			}
			setTimeout(()=>{
				if(this.timer){
					clearInterval(this.timer);
				}
			},120000) // 2分钟之后不再查询订单，跳转到首页
		},
		destroyed() {
			clearInterval(this.timer)
		},
		methods:{
			async defalutShare() {
				let params = {
					type: 1
				}
				let res = await cardShareInfo(params)
				if(res && res.ok){
					let data = res.data
					if(this.s !== 'BS'){
						this.WechatShare({
							title: data.title,
							desc: data.desc,
							imgUrl: data.imgUrl,
							link: data.linkUrl
						}, window.initUrl ? window.initUrl : '')
					}
				}
			},
			// 查询支付结果
			getPayResult(){
				if(this.requestOrderId){
					this.getPayResultByRequestId()
				}else if(this.orderId){
					this.getPayResultByOrderId()
				}
			},
			// 通过支付单id查询订单状态
			getPayResultByRequestId(){
				reqGetPayResult({requestOrderId: this.requestOrderId}).then((res)=>{
					this.loading = true
					if(res.ok && !isEmptyObject(res)){
						console.log('成功：getPayResultByRequestId', res)
						clearInterval(this.timer);
						this.phone = res.data.consigneeMobile
						this.date = res.data.vipEndTimeStr
						if(!this.orderId){
							this.orderId = res.data.orderId
						}
						Toast.clear()
					}else {
						Toast(res.msg)
					}
				})
			},
			// 通过订单id查询订单状态
			getPayResultByOrderId(){
				reqPayResultConfirmByOrderId({orderId: this.orderId}).then((res)=>{
					this.loading = true
					if(res.ok && !isEmptyObject(res)){
						console.log('成功：getPayResultByOrderId', res)
						clearInterval(this.timer);
						this.phone = res.data.consigneeMobile
						this.date = res.data.vipEndTimeStr
						if(!this.orderId){
							this.orderId = res.data.orderId
						}
						Toast.clear()
					}else {
						Toast(res.msg)
					}
				})
			},
			// 分享通知
			share(){
				// 公众号显示提示弹框
        let ua = navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i)=="micromessenger" || isMini()){ // 微信环境和小程序环境
          this.shareTipShow = true
					this.goShare()
        }else if(this.s === 'BS' && Number( localStorage.getItem('clearNav')) === 1){ // 老板云APP
					this.goShare()
				} else {
					this.browserShareTipShow = true
				} 
			},
			// 调用分享
			async goShare(){
				let params = {
					busId: this.orderId,
					type: 4
				}
				let res = await cardShareInfo(params)
				if(res && res.ok){
					let data = res.data
					if(this.s === 'BS'){
						this.bsShareUrl = 'jsb://action=wxShare?platformType=3'+'&title='+data.title+'&desc='+data.desc+'&outLinkUrl='+data.linkUrl
						bridge(this.bsShareUrl)
					} else if(this.s === 'BSM'){
            this.WX.miniProgram.postMessage({ data: {name: this.$route.meta.title, title:data.title } })
          }else {
						this.WechatShare({
							title: data.title,
							desc: data.desc,
							imgUrl: data.imgUrl,
							link: data.linkUrl
						}, window.initUrl ? window.initUrl : '')
					}
				}
			},
			goPath(url){
				this.$router.push({path:url})
			},
      goHome() {
      if (this.s === 'BSM') {
        this.WX.miniProgram.reLaunch({
        url: '/pages/policySubsidy/index'
        })
      } else {
        this.goPath('/home')
      }
      },
		},
	};
</script>

<style lang="less" scoped>
	.success-code {
		padding: 0 30px;
		position: relative;
		.close {
			position: absolute;
			top: 16px;
			left: 16px;
		}
		.close.bsStyle {
			top: 46px;
		}
		.success-code-wrap{
			display: flex;
			flex-direction: column;
			align-items: center;
			.logo {
				height: 60px;
				line-height: 60px;
				margin-top: 110px;
			}
			/deep/ .iconfont {
				font-size: 60px;
				color: @baseGreen;
			}
			.success-text {
				margin-top: 20px;
				height:24px;
				font-size:24px;
				font-family:PingFangSC-Semibold,PingFang SC;
				font-weight:600;
				color:@darkBlack;
				line-height:24px;
			}
			.desc {
				margin-bottom: 10px;
				font-size: 12px;
				color: @subBlack;
			}
			.desc1 {
				margin-top: 20px;
				color: #FA9D3B;
			}
			.date {
				color: @darkBlack;
				margin-left: 6px
			}
			.btn {
				margin-top: 110px;
			}
			.free-btn{
				margin-top: 16px;
				font-size: 16px;
			}
		}
	}
</style>
